import React, { useEffect, useState } from "react";
import { PrivacyPolicyContainer } from "../../style/StyleComponentUtility";
import { useLocation, useNavigate } from "react-router-dom";
import * as L from '../../style/StyleComponentLogin';

const PrivacyPolicy: React.FC = () => {
    const navigate = useNavigate();
    const locationHook = useLocation();
    const [currentLastUrl, setCurrentLastUrl] = useState<string | null>('');

    useEffect(() => {
    const splitUrl = locationHook?.pathname?.split('/') ?? null;
    const location: string | null = splitUrl?.length > 1 ? splitUrl[splitUrl.length -1] : null;
    setCurrentLastUrl(location);
    }, [currentLastUrl, locationHook]);

  return (
    <>
        {currentLastUrl === 'privacy_policy_no_session' && (
            <L.LoginHeader>
                <ul>
                    <li className="login-top-bar-logo" onClick={() => navigate('/login')}>
                        <img src={require('../../assets/images/ablack_logo_w.png')} alt="" width="100%" />
                    </li>
                    <li className="login-top-bar-text">
                        <p>A.Black B2B 통합 관리 시스템</p>
                    </li>
                </ul>
            </L.LoginHeader>
        )}
      <PrivacyPolicyContainer>
        <h1 className="privacy-title">개인정보처리방침</h1>
        <div className="terms_title"><p className="noto_b f-size-18">앰비언스(이하 회사)는 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은<br /> 처리방침을 두고 있습니다.</p></div>


        <div className="terms_title"><p className="noto_b f-size-18">회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.</p></div>



        <div className="terms_title"><p className="noto_b f-size-18">1. 개인정보 수집 및 이용 목적</p></div>



        <div className="terms_title"><p className="noto_b f-size-18">회사는 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.</p></div>


        <div className="terms_content">
            <p className="noto_r f-size-16">가. 홈페이지 회원가입 및 관리
                <span className="terms-indent">
                    회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 각종 고지·통지, 고충처리, 분쟁 조정을 위한 기록 보존 등을 목적으로 개인정보를 처리합니다.
                </span>
            </p>

            <p className="noto_r f-size-16">나. 민원사무 처리
                <span className="terms-indent">
                    민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 등을 목적으로 개인정보를 처리합니다.
                </span>
            </p>

            <p className="noto_r f-size-16">다. 재화 또는 서비스 제공
                <span className="terms-indent">
                    물품배송, 서비스 제공, 청구서 발송, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 연령인증, 요금결제·정산 등을 목적으로 개인정보를 처리합니다.
                </span>
            </p>

            <p className="noto_r f-size-16">라. 마케팅 및 광고에의 활용
                <span className="terms-indent">
                    신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공 , 인구통계학적 특성에 따른 서비스 제공 및 광고 게재 , 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.
                </span>
            </p>
        </div>


        <div className="terms_title"><p className="noto_b f-size-18">2. 수집하는 개인정보의 항목 및 수집방법</p></div>



        <div className="terms_title"><p className="noto_b f-size-18">① 수집 항목</p></div>


        <div className="terms_content">
            <p className="noto_r f-size-16">
            가. 회원 가입 시 수집항목
                <span className="terms-indent">
                    - 필수항목 : 이름, 성별, 로그인ID, 비밀번호, 이메일, 생년월일, 주소, 휴대폰번호
                </span>
                <span className="terms-indent">
                    - 선택항목 : 자택번호, SMS 수신동의, 이메일 수신동의
                </span>
                <span className="terms-indent">
                    - 수집목적 : 회원특정 및 고지사항 전달, 본인의사 확인 및 불만처리 등 원활한 의사소통 경로의 확보
                </span>
            </p>

            <p className="noto_r f-size-16">
                나. 상품구매 시 수집항목
                <span className="terms-indent">
                    - 주문고객정보 : 주문자 이름, 이메일주소, 휴대폰번호, 전화번호, 주소지, 배송시 요청사항
                </span>
                <span className="terms-indent">
                    - 배송지정보: 수령인 이름, 휴대폰번호, 전화번호, 주소, 배송지 요구사항
                </span>
                <span className="terms-indent">
                    - 결제정보 : 결제를 진행하기 위해 필요한 결제 관련 정보 (신용카드, 결제 계좌정보)
                </span>
            </p>

            <p className="noto_r f-size-16">
                다. 자동 수집
                <span className="terms-indent">
                - 결제기록, 접속 IP 정보, 쿠키, 서비스 이용 기록, 접속로그 등
                </span>
            </p>

            <p className="noto_r f-size-16">
                라. 기타 (이벤트나 마케팅 활동 등)
                <span className="terms-indent">
                - 수집정보 : 주소, 생년월일, 전화번호, 휴대폰번호, 이름, 이메일 등
                </span>
                <span className="terms-indent">
                - 그 외 특정 목적을 위해 단기적으로 개인정보를 수집할 경우에는 별도로 공지하고 수집합니다.
                </span>
            </p>
        </div>

        <div className="terms_title"><p className="noto_b f-size-18">② 수집 방법</p></div>

        <div className="terms_content">
            <p className="noto_r f-size-16">
                다음과 같은 방법으로 개인정보를 수집합니다.
                <span className="terms-indent">
                    -홈페이지(회원가입), 서면양식, 전화, 팩스, 상담게시판, 이벤트응모, 배송요청(비회원 구매 포함), 서비스이용, 회원정보 수정
                </span>
                <span className="terms-indent">
                    -제휴회사로부터의 제공
                </span>
            </p>
        </div>

        <div className="terms_title"><p className="noto_b f-size-18">3. 개인정보 수집에 대한 동의</p></div>

        <div className="terms_content">
            <p className="noto_r f-size-16">
                회사는 귀하께서 회사의 개인정보취급방침 또는 이용약관의 내용에 대해 「동의함」 버튼을 체크할 수 있는 절차를 마련하여, 「동의함」버튼을 체크하면 개인정보 수집에 대해 동의한 것으로 봅니다.
            </p>
        </div>


        <div className="terms_title"><p className="noto_b f-size-18">4. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</p></div>

        <div className="terms_content">
            <p className="noto_r f-size-16">
                ① 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.
            </p>

            <p className="noto_r f-size-16">
                ② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.
            </p>


            <p className="noto_r f-size-16">
            <span className="terms-indent">
                가. 쿠키의 사용 목적 : 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.
            </span>


            <span className="terms-indent">
                나. 쿠키의 설치·운영 및 거부 : 웹브라우저 상단의 ‘도구 &gt; 인터넷 옵션 &gt; 개인정보’ 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.
            </span>

            <span className="terms-indent">
                다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.
            </span>
        </p>
        </div>

        <div className="terms_title"><p className="noto_b f-size-18">5. 개인정보의 처리 및 보유 기간</p></div>


        <div className="terms_content">
            <p className="noto_r f-size-16">
                가. 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집시에 동의 받은 개인정보 보유,이용기간 내에서 개인정보를 처리,보유합니다.
            </p>


            <p className="noto_r f-size-16">
                나. 각각의 개인정보 처리 및 보유 기간은 다음과 같이 수집 목적 또는 제공 받은 목적이 달성되면 파기됩니다.
                <span className="terms-indent">
                    - 회원가입 정보 : 회원을 탈퇴하거나 회원에서 제명된 때
                </span>
                <span className="terms-indent">
                    - 대금지급 정보 : 대금의 완제일 또는 채권소멸시효기간이 만료된 때
                </span>
                <span className="terms-indent">
                    - 배송정보 : 재화 또는 용역 등 상품이 인도되거나 제공된 때
                </span>
                <span className="terms-indent">
                    - 설문조사, 이벤트 등 일시적 목적을 위하여 수집한 경우 : 당해 설문조사, 이벤트 등이 종료한 때
                </span>
            </p>
            <p className="noto_r f-size-16">
            다. 단, 상법 및 ‘전자상거래등에서 소비자 보호에 관한 법률’ 등 관련 법령의 규정에 의하여 다음과 같이 거래 관련 권리 의무 관계의 확인 등을 이유로 일정기간 보유하여야 할 필요가 있을 경우에는 일정기간 보유합니다.
                <span className="terms-indent">
                - 계약 또는 청약철회 등에 관한 기록 : 5년
                </span>
                <span className="terms-indent">
                - 대금결제 및 재화등의 공급에 관한 기록 : 5년
                </span>
                <span className="terms-indent">
                - 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년
                </span>
            </p>
        </div>
        <div className="terms_title"><p className="noto_b f-size-18">6. 개인정보의 제3자 제공 및 공유</p></div>


        <div className="terms_content">
            <p className="noto_r f-size-16">
                회사는 이용자의 동의가 있거나 관련 법령의 규정에 의한 경우를 제외하고는 어떠한 경우에도 "개인정보의 수집항목 및 수집 목적", "개인정보의 이용목적"에서 고지한 범위를 넘어 이용자의 개인정보를 이용하거나 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.
            <span className="terms-indent">
            - 이용자들이 사전에 동의한 경우.
            </span>
            <span className="terms-indent">
            - 서비스 제공에 따른 요금정산을 위해 필요한 경우.
            </span>
            <span className="terms-indent">
            - 계약 이행을 위해 필요한 경우(제품 배송/설치, 서비스 업무)
            </span>
            <span className="terms-indent">
            - 타인에게 정신적, 물질적 피해를 줌으로써 그에 대한 법적 조치를 취하기 위해 고객정보를 공개해야 한다고 판단되는 충분한 근거가 있는 경우.
            </span>
            <span className="terms-indent">
            - 통계작성, 마케팅분석 또는 시장조사를 위해 필요한 경우로 특정 개인을 식별할 수 없는 형태로 가공하여 외부 기관 또는 단체 등에 제공하는 경우.
            </span>
            <span className="terms-indent">
            - 기타 관련 법령의 규정에 의하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우.
            </span>
            <span className="terms-indent">
            - 서비스의 제공에 관한 계약의 이행을 위하여 필요한 개인정보로서 경제적/기술적인 사유로 통상의 동의를 받는 것이 현저히 곤란한 경우.
            </span>
            </p>
        </div>

        <div className="terms_title"><p className="noto_b f-size-18">7. 정보주체의 권리, 의무 및 그 행사방법 이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.</p></div>


        <div className="terms_content">
            <p className="noto_r f-size-16">
                가. 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
                <span className="terms-indent">
                - 개인정보 열람요구
                </span>
                <span className="terms-indent">
                - 오류 등이 있을 경우 정정 요구
                </span>
                <span className="terms-indent">
                - 삭제요구
                </span>
                <span className="terms-indent">
                - 처리정지 요구
                </span>
            </p>

            <p className="noto_r f-size-16">
                나. 제1항에 따른 권리 행사는회사에 대해 개인정보 보호법 시행규칙 별지 제8호 서식에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.
            </p>

            <p className="noto_r f-size-16">
                다. 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.
            </p>

            <p className="noto_r f-size-16">
                라. 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
            </p>
        </div>


        <div className="terms_title"><p className="noto_b f-size-18">8. 개인정보의 파기회사는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.</p></div>


        <div className="terms_content">
            <p className="noto_r f-size-16">
                가. 파기절차
                <span className="terms-indent">
                    이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
                </span>
            </p>

            <p className="noto_r f-size-16">
                나. 파기기한
                <span className="terms-indent">
                    이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.
                </span>
            </p>
            <p className="noto_r f-size-16">
                다. 파기방법
                <span className="terms-indent">
                    전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.
                </span>
                <span className="terms-indent">
                    종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
                </span>
            </p>
        </div>

        <div className="terms_title"><p className="noto_b f-size-18">9. 개인정보의 안전성 확보 조치 회사는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.</p></div>


        <div className="terms_content">
            <p className="noto_r f-size-16">
                가. 개인정보 취급 직원의 최소화 및 교육
                <span className="terms-indent">
                개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.
                </span>
            </p>

            <p className="noto_r f-size-16">
                나. 정기적인 자체 감사 실시
                <span className="terms-indent">
                개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를 실시하고 있습니다.
                </span>
            </p>

            <p className="noto_r f-size-16">
                다. 내부관리계획의 수립 및 시행
                <span className="terms-indent">
                개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
                </span>
            </p>

            <p className="noto_r f-size-16">
                라. 개인정보의 암호화
                <span className="terms-indent">
                이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
                </span>
            </p>

            <p className="noto_r f-size-16">
                마. 해킹 등에 대비한 기술적 대책
                <span className="terms-indent">
                회사은 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
                </span>
            </p>

            <p className="noto_r f-size-16">
                바. 개인정보에 대한 접근 제한
                <span className="terms-indent">
                개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
                </span>
            </p>

            <p className="noto_r f-size-16">
                사. 접속기록의 보관 및 위변조 방지
                <span className="terms-indent">
                개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능 사용하고 있습니다.
                </span>
            </p>

            <p className="noto_r f-size-16">
                아. 문서보안을 위한 잠금장치 사용
                <span className="terms-indent">
                개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.
                </span>
            </p>

            <p className="noto_r f-size-16">
                자. 비인가자에 대한 출입 통제
                <span className="terms-indent">
                개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.
                </span>
            </p>
        </div>

        <div className="terms_title"><p className="noto_b f-size-18">10. 개인정보 보호책임자</p></div>


        <div className="terms_content">
            <p className="noto_r f-size-16">
                가. 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                <span className="terms-indent">
                성명 : 
                </span>
                <span className="terms-indent">
                직책: 
                </span>
                <span className="terms-indent">
                소속부서 : 
                </span>
                <span className="terms-indent">
                전화번호 : 
                </span>
                <span className="terms-indent">
                팩스번호 : 
                </span>
                <span className="terms-indent">
                전자우편 : 
                </span>
            </p>

            <p className="noto_r f-size-16">
                나. 정보주체께서는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
            </p>
        </div>


        <div className="terms_title"><p className="noto_b f-size-18">11. 개인정보 처리방침 변경</p></div>


        <div className="terms_content">
            <p className="noto_r f-size-16">
                가. 이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
            </p>
        </div>




        <div className="terms_title"><p className="noto_b f-size-18">본 방침은 2021. 10. 1. 부터 시행됩니다.</p></div>
        {/* <div className="antiemail">
          <p className="law">제1장 총칙</p>
          <p className="intro">제1조 (목적)</p>
          <p className="law-content">
            본 약관은 서비스 이용자가 <strong>앰비언스</strong>(이하 "회사"라
            합니다)가 제공하는 온라인상의 인터넷 서비스(이하 "서비스"라고 하며, 접속
            가능한 유무선 단말기의 종류와는 상관없이 이용 가능한 "회사"가 제공하는
            모든 "서비스"를 의미합니다. 이하 같습니다)에 회원으로 가입하고 이를
            이용함에 있어 회사와 회원(본 약관에 동의하고 회원등록을 완료한 서비스
            이용자를 말합니다. 이하 "회원"이라고 합니다)의 권리 의무 및 책임사항을
            규정함을 목적으로 합니다.
          </p>
          <p className="intro">제2조 (약관의 명시, 효력 및 개정)</p>
          <p className="law-content">
            ① 회사는 이 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기 화면에
            게시합니다. <br />
            ② 회사는 온라인 디지털콘텐츠산업 발전법, 전자상거래 등에서의
            소비자보호에 관한 법률, 약관의 규제에 관한 법률, 소비자기본법 등
            관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다. <br />
            ③ 회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의
            적용일자와 개정사유를 명시하여 현행약관과 함께 그 적용일자 일십오(15)일
            전부터 적용일 이후 상당한 기간 동안, 개정 내용이 회원에게 불리한
            경우에는 그 적용일자 삼십(30)일 전부터 적용일 이후 상당한 기간 동안 각각
            이를 서비스 홈페이지에 공지하고 기존 회원에게는 회사가 부여한 이메일
            주소로 개정약관을 발송하여 고지합니다. <br />
            ④ 회사가 전항에 따라 회원에게 통지하면서 공지 고지일로부터 개정약관
            시행일 7일 후까지 거부의사를 표시하지 아니하면 승인한 것으로 본다는 뜻을
            명확하게 고지하였음에도 의사표시가 없는 경우에는 변경된 약관을 승인한
            것으로 봅니다. 회원이 개정약관에 동의하지 않을 경우 회원은 제17조
            제1항의 규정에 따라 이용계약을 해지할 수 있습니다.
          </p>

          <p className="law">제2장 회원의 가입 및 관리</p>
          <p className="intro">제3조 (회원가입절차)</p>
          <p className="law-content">
            ① 서비스 이용자가 본 약관을 읽고 "동의" 버튼을 누르거나 "확인" 등에
            체크하는 방법을 취한 경우 본 약관에 동의한 것으로 간주합니다.<br />
            ② 회사의 서비스 이용을 위한 회원가입은 서비스 이용자가 제1항과 같이
            동의한 후, 회사가 정한 온라인 회원가입 신청서에 회원 ID를 포함한
            필수사항을 입력하고, "등록하기" 내지 "확인" 단추를 누르는 방법으로
            합니다. 다만, 회사가 필요하다고 인정하는 경우 회원에게 별도의 서류를
            제출하도록 할 수 있습니다.<br />
            ③ 법인고객 회원가입의 경우 회원가입 신청서의 제출, 서비스 이용대금의
            납부 이외에 회사가 정하는 추가 서류의 제출이 추가적으로 필요합니다.<br />
            ④ 법인고객 회원가입의 경우 서비스 이용자와 이용요금 납입자가 다를 경우
            회사는 이를 확인하기 위하여 제 증명을 요구할 수 있습니다.
          </p>
          <p className="intro">제4조 (회원등록의 성립과 유보 및 거절)</p>
          <p className="law-content">
            ① 회원등록은 제3조에 정한 절차에 의한 서비스 이용자의 회원가입 신청과
            회사의 회원등록 승낙에 의하여 성립합니다. 회사는 회원가입 신청자가
            필수사항 등을 성실히 입력하여 가입신청을 완료하였을 때에는 필요한 사항을
            확인한 후 지체 없이 이를 승낙을 하여야 합니다. 단 회원가입 신청서 제출
            이외에 별도의 자료 제출이 요구되는 경우에는 예외로 합니다. <br />
            <br />
            ② 회사는 아래 각 호의 1에 해당하는 경우에는 회원등록의 승낙을 유보할 수
            있습니다. <br />
            <br />
            1. 제공서비스 설비용량에 현실적인 여유가 없는 경우 <br />
            2. 서비스를 제공하기에는 기술적으로 문제가 있다고 판단되는 경우 <br />
            3. 법인 고객으로 가입신청을 하고 제3조 제3항 내지 제4항의 의무를
            이행하지 않은 경우 <br />
            4. 기타 회사가 재정적, 기술적으로 필요하다고 인정하는 경우 <br />
            <br />
            ③ 회사는 아래 각 호의 1에 해당하는 경우에는 회원등록을 거절할 수
            있습니다. <br />
            <br />
            1. 가입신청서의 내용을 허위로 기재하였거나 허위서류를 첨부하여
            가입신청을 하는 경우 <br />
            2. 법인 고객으로 가입신청을 하고 회사가 별도로 규정하는 일정한 기간
            이내에 제3조 제3항 내지 제4항의 의무를 이행하지 않은 경우 <br />
            3. 14세 미만의 아동이 개인정보제공에 대한 동의를 부모 등
            법정대리인으로부터 받지 않은 경우 <br />
            4. 기타 회사가 관련법령 등을 기준으로 하여 명백하게 사회질서 및
            미풍양속에 반할 우려가 있음을 인정하는 경우 5. 제17조제2항에 의하여
            회사가 계약을 해지했던 회원이 다시 회원 신청을 하는 경우
          </p>
          <p className="intro">제5조 (회원 ID 등의 관리책임)</p>
          <p className="law-content">
            ① 회원은 서비스 이용을 위한 회원 ID, 비밀번호의 관리에 대한 책임, 본인
            ID의 제3자에 의한 부정사용 등 회원의 고의 과실로 인해 발생하는 모든
            불이익에 대한 책임을 부담합니다. 단, 이것이 회사의 고의 과실로 인하여
            야기된 경우는 회사가 책임을 부담합니다. <br />
            ② 회원은 회원 ID, 비밀번호 및 추가정보 등을 도난 당하거나 제3자가
            사용하고 있음을 인지한 경우에는 즉시 본인의 비밀번호를 수정하는 등의
            조치를 취하여야 하며 즉시 이를 회사에 통보하여 회사의 안내를 따라야
            합니다.
          </p>
          <p className="intro">제6조 (개인정보의 수집 등)</p>
          <p className="law-content">
            회사는 서비스를 제공하기 위하여 관련 법령의 규정에 따라 회원으로부터
            필요한 개인정보를 수집합니다.<br />
            <br />
            1. 생년월일, 거주지역 및 연락처 등<br />
            2. 우편/경품 수신 주소, 취미, 관심사 등<br />
            3. 서비스별 뉴스레터 수신 여부 등<br />
            4. 기타 회사가 인정하는 사항
          </p>
          <p className="intro">제7조 (회원정보의 변경)</p>
          <p className="law-content">
            회원은 아래 각 호의 1에 해당하는 사항이 변경되었을 경우 즉시 회원정보
            관리페이지에서 이를 변경하여야 합니다. <br />
            이 경우 회사는 회원이 회원정보를 변경하지 아니하여 발생한 손해에 대하여
            책임을 부담하지 아니하며, 법인 회원의 경우에는 회사가 별도로 정하는
            방법으로 변경할 수 있습니다.
          </p>

          <p className="law">제3장 서비스의 이용</p>
          <p className="intro">제8조 (서비스 이용)</p>
          <p className="law-content">
            ① 서비스 이용은 회사의 서비스 사용승낙 직후부터 가능합니다. 다만, 유료
            서비스의 경우 회사가 요금납입을 확인한 직후부터 가능하게 할 수 있습니다.
            <br />
            ② 민법상 미성년자인 회원이 유료 서비스를 이용할 경우 미성년자인 회원은
            결제 전 법정대리인의 동의를 얻어야 합니다. <br />
            ③ 서비스 이용시간은 회사의 업무상 또는 기술상 불가능한 경우를 제외하고는
            연중무휴 1일 24시간(00:00-24:00)으로 함을 원칙으로 합니다. 다만,
            서비스설비의 정기점검 등의 사유로 회사가 서비스를 특정범위로 분할하여
            별도로 날짜와 시간을 정할 수 있습니다.
          </p>
          <p className="intro">제9조 (서비스내용변경 통지 등)</p>
          <p className="law-content">
            ① 회사가 서비스 제공을 위해 계약한 CP(Contents Provider)와의 계약종료,
            CP의 변경, 신규서비스의 개시 등의 사유로 서비스 내용이 변경되거나
            서비스가 종료되는 경우 회사는 회원의 등록된 전자우편 주소로 이메일을
            통하여 서비스 내용의 변경 사항 또는 종료를 통지할 수 있습니다. <br />
            ② 전항의 경우 불특정 다수인을 상대로 통지를 함에 있어서는 웹사이트 기타
            회사의 공지사항 페이지를 통하여 회원들에게 통지할 수 있습니다. 단, 회원
            본인의 거래와 관련하여 중대한 영향을 미치는 사항은 상당한 기간 동안
            게시판을 통해 이를 공지하고 회사가 부여한 이메일 주소로 개별통지 합니다.
            <br />
            ③ 유료 서비스가 종료되는 경우에는 서비스를 이용하는 회원에게 반드시
            제1항의 규정에 따라 이메일을 통하여 이를 고지하며 제16조 제4항의 규정에
            따라 환불 처리합니다.
          </p>
          <p className="intro">제10조 (권리의 귀속 및 저작물의 이용)</p>
          <p className="law-content">
            ① 회원이 서비스 내에 게시한 게시물 등(이하 "게시물 등"이라 합니다)의
            저작권은 해당 게시물의 저작자에게 귀속됩니다. <br />
            ② 게시물 등은 검색결과 내지 서비스 및 관련 프로모션 등에 노출될 수
            있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 복제, 편집되어
            게시될 수 있습니다. 이 경우, 회사는 저작권법 규정을 준수하며, 회원은
            언제든지 고객센터 또는 각 서비스 내 관리기능을 통해 해당 게시물 등에
            대해 삭제, 검색결과 제외, 비공개 등의 조치를 취할 수 있습니다. <br />
            ③ 회사는 제2항 이외의 방법으로 회원의 게시물 등을 이용하고자 하는
            경우에는 전화, 팩스, 전자우편 등을 통해 사전에 회원의 동의를 얻습니다.
          </p>
          <p className="intro">제11조 (서비스 이용의 제한 및 중지)</p>
          <p className="law-content">
            ① 회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 회원의 서비스
            이용을 제한하거나 중지시킬 수 있습니다. <br />
            <br />
            1. 회원이 회사 서비스의 운영을 고의·과실로 방해하는 경우 <br />
            2. 회원이 제13조의 의무를 위반한 경우 <br />
            3. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우 <br />
            4. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을
            경우 <br />
            5. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로
            서비스 이용에 지장이 있는 때 <br />
            6. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이
            부적당하다고 인정하는 경우 <br />
            <br />
            ② 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는
            그 사유 및 제한기간등을 회원에게 알려야 합니다. <br />
            ③ 제17조제2항에 의해 회사가 회원과의 계약을 해지하고 탈퇴시키기로 결정한
            경우 회사는 회원의 탈퇴 처리 전에 이를 통지하고, 회원은 회사의 통지를
            받은 날로부터 30일 이내에 이에 대한 항변의 기회를 가집니다. <br />
            ④ 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 "정보통신망법"이라
            합니다)의 규정에 의해 다른 회원의 공개된 게시물 등이 본인의 사생활을
            침해하거나 명예를 훼손하는 등 권리를 침해 받은 회원 또는 제3자(이하
            "삭제 등 신청인"이라 합니다)는 그 침해사실을 소명하여 회사에 해당 게시물
            등의 삭제 또는 반박 내용의 게재를 요청할 수 있습니다. 이 경우 회사는
            해당 게시물 등의 권리 침해 여부를 판단할 수 없거나 당사자 간의 다툼이
            예상되는 경우 해당 게시물 등에 대한 접근을 임시적으로 차단하는 조치(이하
            "임시조치"라 합니다)를 최장 30일까지 취합니다. <br />
            ⑤ 제5항에 의해 본인의 게시물 등이 임시조치된 회원(이하 "게시자"라
            합니다)은 임시조치기간 중 회사에 해당 게시물 등을 복원해 줄 것을
            요청(이하 "재게시 청구"라 합니다)할 수 있으며, 회사는 임시조치된
            게시물의 명예훼손 등 판단에 대한 방송통신심의위원회 심의 요청에 대한
            게시자 및 삭제 등 신청인의 동의가 있는 경우 게시자 및 삭제 등 신청인을
            대리하여 이를 요청하고 동의가 없는 경우 회사가 이를 판단하여 게시물 등의
            복원 여부를 결정합니다. 게시자의 재게시 청구가 있는 경우 임시조치 기간
            내에 방송통신심의위원회 또는 회사의 결정이 있으면 그 결정에 따르고 그
            결정이 임시조치 기간 내에 있지 않는 경우 해당 게시물 등은 임시조치
            만료일 이후 복원됩니다. 재게시 청구가 없는 경우 해당 게시물 등은
            임시조치 기간 만료 이후 삭제됩니다. <br />
            ⑦ 회사는 서비스 내에 게시된 게시물 등이 사생활 침해 또는 명예훼손 등
            제3자의 권리를 침해한다고 인정하는 경우 제5항에 따른 회원 또는 제3자의
            신고가 없는 경우에도 임시조치(이하 "임의의 임시조치"라 합니다)를 취할 수
            있습니다. 임의의 임시조치된 게시물의 처리 절차는 제5항 후단 및 제6항의
            규정에 따릅니다. <br />
            ⑧ 회원의 게시물 등으로 인한 법률상 이익 침해를 근거로, 다른 회원 또는
            제3자가 회원 또는 회사를 대상으로 하여 민형사상의 법적 조치(예:
            형사고소, 가처분 신청·손해배상청구 등 민사소송의 제기)를 취하는 경우,
            회사는 동 법적 조치의 결과인 법원의 확정판결이 있을 때까지 관련 게시물
            등에 대한 접근을 잠정적으로 제한할 수 있습니다. 게시물 등의 접근 제한과
            관련한 법적 조치의 소명, 법원의 확정 판결에 대한 소명 책임은 게시물 등에
            대한 조치를 요청하는 자가 부담합니다.
          </p>
          <p className="intro">제12조 (회사의 의무)</p>
          <p className="law-content">
            ① 회사는 회사의 서비스 제공 및 보안과 관련된 설비를 지속적이고 안정적인
            서비스 제공에 적합하도록 유지, 점검 또는 복구 등의 조치를 성실히
            이행하여야 합니다. <br />
            ② 회사는 회원이 수신 동의를 하지 않은 영리 목적의 광고성 전자우편, SMS
            문자메시지 등을 발송하지 아니합니다. <br />
            ③ 회사는 서비스의 제공과 관련하여 알게 된 회원의 개인정보를 본인의 승낙
            없이 제3자에게 누설, 배포하지 않고, 이를 보호하기 위하여 노력합니다.
            회원의 개인정보보호에 관한 기타의 사항은 정보통신망법 및 회사가 별도로
            정한 "개인정보관리지침"에 따릅니다. <br />
            ④ 회사가 제3자와의 서비스 제공계약 등을 체결하여 회원에게 서비스를
            제공하는 경우 회사는 각 개별서비스에서 서비스의 제공을 위하여 제3자에게
            제공되는 회원의 구체적인 회원정보를 명시하고 회원의 개별적이고 명시적인
            동의를 받은 후 동의의 범위 내에서 해당 서비스의 제공 기간 동안에 한하여
            회원의 개인정보를 제3자와 공유하는 등 관련 법령을 준수합니다.
          </p>
          <p className="intro">제13조 (회원의 의무)</p>
          <p className="law-content">
            ① 회원은 아래 각 호의 1에 해당하는 행위를 하여서는 아니 됩니다. <br />
            <br />
            1. 회원가입신청 또는 변경 시 허위내용을 등록하는 행위 <br />
            2. 회사의 서비스에 게시된 정보를 변경하거나 서비스를 이용하여 얻은
            정보를 회사의 사전 승낙 없이 영리 또는 비영리의 목적으로 복제, 출판,
            방송 등에 사용하거나 제3자에게 제공하는 행위 <br />
            3. 회사가 제공하는 서비스를 이용하여 제3자에게 본인을 홍보할 기회를 제공
            하거나 제3자의 홍보를 대행하는 등의 방법으로 금전을 수수하거나 서비스를
            이용할 권리를 양도하고 이를 대가로 금전을 수수하는 행위 <br />
            4.회사 기타 제3자에 대한 허위의 사실을 게재하거나 지적재산권을 침해하는
            등 회사나 제3자의 권리를 침해하는 행위 <br />
            5. 다른 회원의 ID 및 비밀번호를 도용하여 부당하게 서비스를 이용하는 행위
            <br />
            6. 타인의 계좌번호 및 신용카드번호 등 타인의 허락 없이 타인의 결제정보를
            이용하여 회사의 유료서비스를 이용하는 행위 <br />
            7. 정크메일(junk mail), 스팸메일(spam mail), 행운의 편지(chain letters),
            피라미드 조직에 가입할 것을 권유하는 메일, 외설 또는 폭력적인
            메시지·화상·음성 등이 담긴 메일을 보내거나 기타 공서양속에 반하는 정보를
            공개 또는 게시하는 행위 <br />
            8. 정보통신망법 등 관련 법령에 의하여 그 전송 또는 게시가 금지되는
            정보(컴퓨터 프로그램 등)를 전송하거나 게시하는 행위 <br />
            9. 청소년보호법에서 규정하는 청소년유해매체물을 게시하는 행위 <br />
            10. 공공질서 또는 미풍양속에 위배되는 내용의 정보, 문장, 도형, 음성 등을
            유포하는 행위 <br />
            11. 회사의 직원이나 서비스의 관리자를 가장하거나 사칭하여 또는 타인의
            명의를 모용하여 글을 게시하거나 메일을 발송하는 행위 <br />
            12. 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해,
            파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일,
            프로그램을 포함하고 있는 자료를 게시하거나 전자우편으로 발송하는 행위
            <br />
            13. 스토킹(stalking), 욕설, 채팅글 도배 등 다른 회원의 서비스 이용을
            방해하는 행위 <br />
            14. 다른 회원의 개인정보를 그 동의 없이 수집, 저장, 공개하는 행위 <br />
            15. 불특정 다수의 회원을 대상으로 하여 광고 또는 선전을 게시하거나
            스팸메일을 전송할 목적으로 회사에서 제공하는 프리미엄 메일 기타 서비스를
            이용하여 영리활동을 하는 행위 <br />
            16. 회사가 제공하는 소프트웨어 등을 개작하거나 리버스 엔지니어링,
            디컴파일, 디스어셈블 하는 행위 <br />
            <br />
            17. 현행 법령, 회사가 제공하는 서비스에 정한 약관 기타 서비스 이용에
            관한 규정을 위반하는 행위 <br />
            <br />
            ② 회사는 회원이 제1항의 행위를 하는 경우 해당 게시물 등을 삭제 또는
            임시삭제할 수 있고 서비스의 이용을 제한하거나 일방적으로 본 계약을
            해지할 수 있습니다. <br />
            ③ 회사가 제공하는 서비스 중 관련 법령 등의 규정에 의하여 성인인증이
            필요한 경우 회원은 해당 서비스를 이용하기 위하여 회사가 제공하는 방법에
            따라 실명정보를 회사에 제공하여야 합니다.
          </p>
          <p className="intro">제14조 (양도금지)</p>
          <p className="law-content">
            회원의 서비스 받을 권리는 이를 양도 내지 증여하거나 질권의 목적으로
            사용할 수 없습니다.
          </p>
          <p className="intro">제15조 (이용요금의 납입)</p>
          <p className="law-content">
            ① 회원은 회사가 제공하는 서비스 중 유료서비스를 이용하는 경우 이용대금을
            납부한 후 서비스를 이용하는 것을 원칙으로 합니다. <br />
            ② 회사가 제공하는 유료서비스에 대한 이용요금의 결제 방법은 핸드폰결제,
            신용카드결제, 일반전화결제, 계좌이체, 무통장입금등이 있으며 각
            유료서비스마다 결제 방법의 차이가 있을 수 있습니다. <br />
            ④ 회사는 결제의 이행을 위하여 반드시 필요한 회원의 개인정보를 추가적으로
            요구할 수 있으며, 회원은 회사가 요구하는 개인정보를 정확하게 제공하여야
            합니다. 회사는 회원이 허위로 또는 부정확하게 제공한 개인정보로 인하여
            회원에게 발생하는 손해에 대하여 회사의 고의·과실이 없는 한 회원의 손해를
            배상할 책임을 부담하지 않습니다.
          </p>
          <p className="intro">제16조 (이용요금의 환불 및 이의제기)</p>
          <p className="law-content">
            ① 회원이 과오 납입한 요금에 대하여는 회사는 그 요금을 환불하여야 합니다.
            <br />
            <br />
            ② 회원의 귀책사유로 이용요금을 환불하는 경우 일반적인 방법은 아래와
            같습니다. <br />
            <br />
            1. 회사가 제공하는 유료서비스가 결제 후 1개월(결제 기준) 이하로 지속되는
            서비스인 경우 해지일로부터 이용일수에 해당하는 금액을 제외한 나머지
            금액을 환불합니다. 본 항의 규정은 일(1)개월 단위로 매월 결제되는
            서비스의 경우에도 적용됩니다. <br />
            2. 회사가 제공하는 유료서비스가 결제 후 1개월(결제 기준)을 초과하여
            지속되는 서비스인 경우 해지일로부터 이용일수에 해당하는 금액과 총 남은
            이용일수의 10%를 제외한 금액을 환불합니다. 단, 유료 서비스 이용
            개시일로부터 7일 이내에 해지를 요구하는 경우 이용일수에 해당하는
            금액만을 제외하고 환불합니다. <br />
            <br />
            ③ 제2항의 규정에도 불구하고 아래 각 호의 경우에는 회원이 결제한 전액을
            환불합니다. <br />
            <br />
            1. 회원이 결제를 완료한 후 서비스를 이용한 내역이 없는 경우 <br />
            2. 서비스 장애 또는 회사가 제시한 최소한의 기술사양을 충족하였음에도
            불구하고 회사의 귀책사유로 서비스를 이용하지 못한 경우 <br />
            3. 회원이 구매한 서비스가 제공되지 않은 경우 <br />
            4. 제공되는 서비스가 표시·광고 등과 상이하거나 현저한 차이가 있는 경우
            <br />
            5. 제공되는 서비스의 결함으로 서비스의 정상적인 이용이 현저히 불가능한
            경우 <br />
            <br />
            <br />
            ④ 제3항제2호의 사유 또는 서비스의 중단 등 회사의 귀책사유로 이용요금을
            환불하는 경우 회사는 남은 유료서비스 이용일수에 해당하는 금액과 그
            금액의 10%에 해당하는 금액을 추가적으로 회원에게 환불합니다. 단, 1회의
            구매 완료 후 그 사용기한이 무제한인 서비스는 구매 완료일로부터 1년
            이내일 경우에만 환불합니다. <br />
            ⑤ 회원은 이용요금에 대하여 이의를 제기할 수 있습니다. 단, 이용요금에
            관한 이의는 그 사유 발생을 안 날로부터 1월, 그 사유가 발생한 날로부터
            3월 이내에 제기하여야 합니다. <br />
            ⑥ 회원이 제13조의 규정을 위반하여 회사가 회원의 서비스 이용을 제한하거나
            일방적으로 본 계약을 해지하는 경우 회사는 회원에게 대하여 일체의 환불을
            하지 않습니다. <br />
            ⑦ 전액 환불의 경우 회원이 해당 서비스의 이용을 위하여 이용한
            결제수단으로 환불하는 것을 원칙으로 하나 이것이 불가능 하거나 서비스의
            중도해지로 인한 부분 환불 등의 경우에는 회사가 정하는 별도의 방법으로
            환불합니다. <br />
            ⑧ 본 조의 규정에 의한 환불은 환불 의무가 발생한 날로부터 3영업일 이내에
            하는 것으로 하며 환불이 지연되는 경우 지연이자율은 연리 11%로 합니다.
            단, 환불에 회원의 협조가 필요한 경우에 회원의 귀책사유로 인한 환불
            지연에 대해서는 지연이자를 지급하지 않습니다. <br />
            ⑨ 환불에 소요되는 비용은 회원의 귀책사유로 인한 환불의 경우에는 회원이,
            회사의 귀책사유로 인한 환불의 경우에는 회사가 각각 부담합니다.
          </p>
          <p className="intro">제17조 (이용계약의 해지)</p>
          <p className="law-content">
            ① 회원이 서비스 이용계약을 해지하고자 하는 때에는 언제든지
            회원정보관리에서 회사가 정한 절차에 따라 회원의 ID를 삭제하고 탈퇴할 수
            있습니다. <br />
            ② 회원이 제13조의 규정을 위반한 경우 회사는 일방적으로 본 계약을 해지할
            수 있고, 이로 인하여 서비스 운영에 손해가 발생한 경우 이에 대한 민,
            형사상 책임도 물을 수 있습니다. <br />
            ③ 회원이 서비스를 이용하는 도중, 연속하여 일(1)년 동안 서비스를 이용하기
            위해 회사의 서비스에 log-in한 기록이 없는 경우 회사는 회원의 회원자격을
            상실시킬 수 있습니다. <br />
            ④ 유료서비스 이용계약의 해지는 회원의 서비스 해지신청 및 회사의 승낙에
            의해 성립합니다. 회사가 승낙한 시점에 해지의 효과는 발생하며 환불할
            금액이 있는 경우 환불도 이루어지게 됩니다. 환불에 대해서는 제16조의
            규정을 따릅니다. <br />
            ⑤ 각 개별 유료서비스에서 제4항의 규정과 다른 계약해지의 방법 및 효과를
            개별 약관에서 규정하고 있는 경우 각 개별 유료서비스의 계약해지에
            관해서는 당해 개별약관의 규정을 따릅니다. <br />
            ⑥ 본 이용 계약이 해지된 경우 회원 본인 계정에 등록된 '게시물 등' 일체는
            삭제됩니다.
          </p>

          <p className="law">제4장 기타</p>
          <p className="intro">제18조 (청소년 보호)</p>
          <p className="law-content">
            회사는 모든 연령대가 자유롭게 이용할 수 있는 공간으로써 유해 정보로부터
            청소년을 보호하고 청소년의 안전한 인터넷 사용을 돕기 위해
            정보통신망법에서 정한 청소년보호정책을 별도로 시행하고 있으며, 구체적인
            내용은 서비스 초기 화면 등에서 확인할 수 있습니다.
          </p>
          <p className="intro">제19조 (면책)</p>
          <p className="law-content">
            ① 회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여
            회원에게 발생한 손해에 대해서는 책임을 부담하지 않습니다. <br />
            <br />
            1. 천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우 <br />
            2. 서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의 고의적인
            서비스 방해가 있는 경우 <br />
            3. 회원의 귀책사유로 서비스 이용에 장애가 있는 경우 <br />
            4. 제1호 내지 제3호를 제외한 기타 회사의 고의·과실이 없는 사유로 인한
            경우 <br />
            <br />
            ② 회사는 CP가 제공하거나 회원이 작성하는 등의 방법으로 서비스에 게재된
            정보, 자료, 사실의 신뢰도, 정확성 등에 대해서는 보증을 하지 않으며 이로
            인해 발생한 회원의 손해에 대하여는 책임을 부담하지 아니합니다.
          </p>
          <p className="intro">제20조 (분쟁의 해결)</p>
          <p className="law-content">
            본 약관은 대한민국법령에 의하여 규정되고 이행되며, 서비스 이용과
            관련하여 회사와 회원간에 발생한 분쟁에 대해서는 민사소송법상의 주소지를
            관할하는 법원을 합의관할로 합니다.
          </p>
          <p className="intro">제21조 (규정의 준용)</p>
          <p className="law-content">
            본 약관에 명시되지 않은 사항에 대해서는 관련법령에 의하고, 법에 명시되지
            않은 부분에 대하여는 관습에 의합니다.
          </p>
          <br />
          <div style={{display: "flex", justifyContent: "center"}}>
            <p>-본 방침은 2019.2.1. 부터 시행됩니다.-</p>
          </div>
        </div> */}
      </PrivacyPolicyContainer>
    </>
  )
};

export default PrivacyPolicy;